<template>
	<div class="education-solution-page">
		<Head />
		<main class="education-main">
			<section class="hero-section section-py">
				<div class="container-custom hero-grid">
					<div class="fade-in">
						<div class="hero-badge">区域教育心理健康一体化解决方案</div>
						<h1>教育局心理测评系统<br>建设方案</h1>
						<p>
							以<span>多级管理·区域划分·责任到校</span>为核心，构建全区统一的学生心理健康测评与管理平台，实现早发现、早预警、早干预，筑牢校园心理健康防线。
						</p>
						<div class="hero-actions">
							<a href="#contact" class="btn-primary">获取完整建设方案</a>
							<a href="#function" class="btn-outline">查看核心功能</a>
						</div>
						<div class="hero-points">
							<div><i class="el-icon-success"></i>五级权限管理</div>
							<div><i class="el-icon-success"></i>一生一档留存</div>
							<div><i class="el-icon-success"></i>家校协同干预</div>
						</div>
					</div>
					<div class="hero-image-wrap fade-in">
						<img src="https://picsum.photos/900/560?random=50" alt="教育局心理测评系统管理大屏">
					</div>
				</div>
			</section>

			<section id="background" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>项目背景与建设依据</h2>
						<div class="title-underline"></div>
						<p>政策要求 + 现实需求 + 工作痛点，驱动区域教育心理健康信息化建设。</p>
					</div>
					<div class="bg-grid">
						<div v-for="item in backgroundCards" :key="item.title" class="card card-hover">
							<div class="icon-wrap"><i :class="item.icon"></i></div>
							<h3>{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
				</div>
			</section>

			<section id="goals" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>六大核心建设目标</h2>
						<div class="title-underline"></div>
						<p>全方位构建区域校园心理健康信息化管理体系，权责清晰、闭环管理。</p>
					</div>
					<div class="goal-grid">
						<div v-for="(item, index) in goalCards" :key="item.title" class="card card-hover">
							<div class="goal-head">
								<span>{{ `0${index + 1}`.slice(-2) }}</span>
								<h3>{{ item.title }}</h3>
							</div>
							<p>{{ item.desc }}</p>
						</div>
					</div>
				</div>
			</section>

			<section id="architecture" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>总体架构</h2>
						<div class="title-underline"></div>
						<p>六级管理端 + 三大核心逻辑，构建全域协同心理健康管理体系。</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">六级管理端架构</h3>
							<div class="stack-list">
								<div v-for="item in architectureCards" :key="item.title" class="stack-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">三大核心管理逻辑</h3>
							<ul class="logic-list">
								<li v-for="item in logicCards" :key="item.title">
									<div class="logic-icon"><i :class="item.icon"></i></div>
									<div>
										<h4>{{ item.title }}</h4>
										<p>{{ item.desc }}</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="function" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>核心功能模块</h2>
						<div class="title-underline"></div>
						<p>八大核心功能，覆盖测评、管理、预警、干预、考核全流程。</p>
					</div>
					<div class="module-grid">
						<div v-for="item in moduleCards" :key="item.title" class="module-card card-hover">
							<div class="module-head">
								<div class="module-icon"><i :class="item.icon"></i></div>
								<h4>{{ item.title }}</h4>
							</div>
							<ul>
								<li v-for="point in item.points" :key="point">{{ point }}</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="implement" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>实施部署与保障体系</h2>
						<div class="title-underline"></div>
						<p>分阶段推进 + 明确分工 + 多重保障，确保项目落地见效、长效运行。</p>
					</div>
					<div class="three-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">实施部署计划</h3>
							<div class="phase-list">
								<div v-for="(item, index) in implementationCards" :key="item.title" class="phase-item">
									<span>{{ `0${index + 1}`.slice(-2) }}</span>
									<div>
										<h4>{{ item.title }}</h4>
										<p>{{ item.desc }}</p>
									</div>
								</div>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">责任体系与分工</h3>
							<ul class="responsibility-list">
								<li v-for="item in responsibilityCards" :key="item.title">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">五大保障措施</h3>
							<div class="safe-list">
								<div v-for="item in safeguardCards" :key="item.title" class="safe-item">
									<h4><i :class="item.icon"></i>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="result-section">
				<div class="container-custom result-box">
					<h2>预期成效与展望</h2>
					<div class="result-grid">
						<div v-for="item in resultCards" :key="item.title" class="result-card card-hover">
							<div class="result-icon"><i :class="item.icon"></i></div>
							<h3>{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
					<!-- <a href="#contact" class="result-btn">立即咨询，定制区域专属建设方案</a> -->
				</div>
			</section>
			<SiteFooter />
		</main>
	</div>
</template>

<script>
import Head from '@/components/head/index.vue'
import SiteFooter from '@/components/footer/index.vue'

export default {
	name: 'EducationSolution',
	components: {
		Head,
		SiteFooter
	},
	data() {
		return {
			backgroundCards: [
				{
					title: '政策要求',
					desc: '全面落实教育部相关政策，将学生心理健康管理作为教育重点任务。',
					icon: 'el-icon-document'
				},
				{
					title: '现实需求',
					desc: '中小学生心理健康问题日益突出，亟需建立科学化、信息化管理体系。',
					icon: 'el-icon-user'
				},
				{
					title: '工作痛点',
					desc: '传统管理易出现数据孤岛、责任不清、预警滞后等问题。',
					icon: 'el-icon-warning'
				},
				{
					title: '建设核心',
					desc: '构建覆盖全区统一平台，打通各级链路，实现早发现早干预。',
					icon: 'el-icon-share'
				}
			],
			goalCards: [
				{
					title: '构建多级管理体系',
					desc: '实现教育局-学区-学校-年级-班级五级权限管理。'
				},
				{
					title: '保障数据安全隐私',
					desc: '落实分级授权、脱敏存储、全程留痕可追溯。'
				},
				{
					title: '实现区域精准划分',
					desc: '按行政区、学区、学段进行分类统计和督导。'
				},
				{
					title: '压实学校主体责任',
					desc: '明确学校为第一责任主体，落实闭环管理。'
				},
				{
					title: '形成闭环工作机制',
					desc: '建立测评、预警、干预、转介、回访完整链条。'
				},
				{
					title: '支撑决策与督导考核',
					desc: '提供态势分析、风险分布、执行进度等数据支持。'
				}
			],
			architectureCards: [
				{
					title: '区级管理端（教育局）',
					desc: '总控、统筹、督导、数据总览'
				},
				{
					title: '学区/片区管理端',
					desc: '区域汇总、督促落实、校际协同'
				},
				{
					title: '校级管理端',
					desc: '主体责任、测评实施、干预管理'
				},
				{
					title: '班级/班主任端',
					desc: '日常观测、初步关怀、信息上报'
				},
				{
					title: '心理教师端',
					desc: '专业测评、个案辅导、危机干预'
				},
				{
					title: '家长端',
					desc: '知情同意、家庭反馈、家校协同'
				}
			],
			logicCards: [
				{
					title: '多级管理（权限分级）',
					desc: '通过分级权限控制，实现数据隔离和精细治理。',
					icon: 'el-icon-s-operation'
				},
				{
					title: '区域划分（网格化管理）',
					desc: '按行政区、学区、学段多维分类统计和可视化展示。',
					icon: 'el-icon-location'
				},
				{
					title: '责任到校（闭环体系）',
					desc: '任务下发、进度追踪、督导考核，责任落实到校。',
					icon: 'el-icon-s-check'
				}
			],
			moduleCards: [
				{
					title: '多级组织架构与权限管理',
					icon: 'el-icon-user',
					points: ['教育局统一创建管理账号', '严格角色权限隔离，操作全程留痕', '满足审计与责任追溯要求']
				},
				{
					title: '测评组织与任务下发系统',
					icon: 'el-icon-s-order',
					points: ['统一制定测评计划并一键下发', '实时监控各校覆盖率和完成率', '对滞后单位自动督导提醒']
				},
				{
					title: '区域网格化管理与数据统计',
					icon: 'el-icon-map-location',
					points: ['区域地图式数据可视化', '多维统计与智能报表生成', '自动形成区域心理健康白皮书']
				},
				{
					title: '学生心理档案与一生一档',
					icon: 'el-icon-document',
					points: ['每位学生建立电子心理档案', '一人一档终身留存动态更新', '权限控制下支持校际流转']
				},
				{
					title: '分级预警与危机干预闭环',
					icon: 'el-icon-bell',
					points: ['红橙黄蓝四级预警机制', '预警信息自动上报分级处置', '从发现到结案完整闭环']
				},
				{
					title: '家校协同与家长端系统',
					icon: 'el-icon-chat-line-round',
					points: ['测评知情同意线上化', '家庭观察信息实时反馈', '家校协同制定干预方案']
				},
				{
					title: '督导考核与责任追溯系统',
					icon: 'el-icon-s-flag',
					points: ['自定义考核指标与评分规则', '自动生成学校得分与排名', '数据不可篡改满足责任倒查']
				},
				{
					title: '数据安全与隐私保护体系',
					icon: 'el-icon-lock',
					points: ['遵循国家隐私保护相关法规', '数据加密、脱敏存储、分级访问', '等保资质认证，安全防护完善']
				}
			],
			implementationCards: [
				{
					title: '平台部署与配置',
					desc: '周期1-2周，完成采购、部署及基础架构搭建。'
				},
				{
					title: '账号开通与培训',
					desc: '周期1-2周，分级开通账号并开展操作培训。'
				},
				{
					title: '测评与数据采集',
					desc: '周期2-4周，统一普测建立区域数据基线。'
				},
				{
					title: '预警处置与干预',
					desc: '长期推进，专业干预并建立医疗转介通道。'
				},
				{
					title: '督导考核与运行',
					desc: '长期运行，常态化督导并生成年度报告。'
				}
			],
			responsibilityCards: [
				{
					title: '教育局',
					desc: '统筹管理，制定政策、组织测评、督导考核、建立转介机制。'
				},
				{
					title: '学区/片区',
					desc: '承上启下，督促落实、汇总数据、协调校际共性问题。'
				},
				{
					title: '学校',
					desc: '主体责任，组织测评、建立档案、落实干预与日常管理。'
				},
				{
					title: '教师/班主任',
					desc: '一线执行，日常观察、测评实施、关怀上报。'
				}
			],
			safeguardCards: [
				{
					title: '组织保障',
					desc: '教育局主要领导牵头，成立项目推进领导小组。',
					icon: 'el-icon-user'
				},
				{
					title: '制度保障',
					desc: '出台配套办法，让心理健康工作有章可循。',
					icon: 'el-icon-document'
				},
				{
					title: '人员保障',
					desc: '配齐专兼职心理教师，开展常态化培训督导。',
					icon: 'el-icon-reading'
				},
				{
					title: '技术与安全',
					desc: '满足等级保护要求，确保系统稳定和数据安全。',
					icon: 'el-icon-setting'
				},
				{
					title: '经费保障',
					desc: '建设、运维、培训纳入年度预算，保障持续投入。',
					icon: 'el-icon-money'
				}
			],
			resultCards: [
				{
					title: '规范化管理新格局',
					desc: '实现全区一张网、多级分层管、责任落到校的统一治理。',
					icon: 'el-icon-s-grid'
				},
				{
					title: '风险防控能力提升',
					desc: '提升早发现早干预覆盖率，降低校园极端事件风险。',
					icon: 'el-icon-shield'
				},
				{
					title: '全方位防护网络',
					desc: '形成教育、学校、家庭、医疗多方协同支持体系。',
					icon: 'el-icon-link'
				}
			],
			contactPersons: [
				{
					name: '张先生',
					phone: '13161072501'
				},
				{
					name: '许女士',
					phone: '15031192537'
				},
				{
					name: '安先生',
					phone: '18932907651'
				}
			],
			consultationForm: {
				name: '',
				phone: '',
				org: '',
				demand: '',
				desc: ''
			}
		}
	},
	mounted() {
		this.scrollToHashTarget()
	},
	watch: {
		'$route.hash'() {
			this.scrollToHashTarget()
		}
	},
	methods: {
		scrollToHashTarget() {
			if (!this.$route.hash) {
				return
			}
			this.$nextTick(() => {
				const target = document.querySelector(this.$route.hash)
				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					})
				}
			})
		},
		handleConsultSubmit() {
			window.alert('咨询信息提交成功！我们将在1个工作日内与您联系。')
			this.consultationForm = {
				name: '',
				phone: '',
				org: '',
				demand: '',
				desc: ''
			}
		}
	}
}
</script>

<style scoped>
.education-solution-page {
	min-height: 100vh;
	background: #f9fafb;
	color: #1d2939;
}

.education-main {
	padding-top: 64px;
}

.section-py {
	padding: 64px 0;
}

.section-soft {
	background: #f3f7fc;
}

.container-custom {
	max-width: 1260px;
	margin: 0 auto;
	padding: 0 20px;
}

.section-head {
	max-width: 780px;
	margin: 0 auto 40px;
	text-align: center;
}

.section-head h2 {
	margin: 0;
	font-size: clamp(30px, 4vw, 46px);
	line-height: 1.3;
}

.section-head p {
	margin: 0;
	font-size: 17px;
	line-height: 1.75;
	color: #5f6f82;
}

.title-underline {
	width: 66px;
	height: 5px;
	margin: 18px auto;
	border-radius: 999px;
	background: #36b37e;
}

.hero-section {
	background: linear-gradient(135deg, rgba(30, 101, 193, 0.07) 0%, rgba(54, 179, 126, 0.07) 100%);
}

.hero-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 30px;
	align-items: center;
}

.hero-badge {
	display: inline-block;
	padding: 8px 14px;
	margin-bottom: 10px;
	border-radius: 999px;
	font-size: 13px;
	color: #1e65c1;
	background: rgba(30, 101, 193, 0.1);
}

.hero-section h1 {
	margin: 0 0 14px;
	font-size: clamp(34px, 5vw, 62px);
	line-height: 1.25;
}

.hero-section p {
	margin: 0;
	font-size: 19px;
	line-height: 1.75;
	color: #4b5563;
}

.hero-section p span {
	font-weight: 700;
	color: #1e65c1;
}

.hero-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	margin: 24px 0 16px;
}

.btn-primary,
.btn-outline {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 12px 24px;
	border-radius: 10px;
	font-size: 15px;
	font-weight: 600;
	text-decoration: none;
	border: 1px solid transparent;
	cursor: pointer;
}

.btn-primary {
	background: #1e65c1;
	border-color: #1e65c1;
	color: #fff;
}

.btn-primary:hover {
	background: #1a58aa;
}

.btn-primary.full {
	width: 100%;
}

.btn-outline {
	color: #1e65c1;
	border-color: #1e65c1;
	background: transparent;
}

.btn-outline:hover {
	background: rgba(30, 101, 193, 0.06);
}

.hero-points {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 8px;
}

.hero-points div {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: #4b5563;
}

.hero-points i {
	color: #1e65c1;
}

.hero-image-wrap {
	background: #fff;
	padding: 10px;
	border-radius: 16px;
	border: 1px solid #dbe5f0;
	box-shadow: 0 12px 28px rgba(30, 101, 193, 0.15);
}

.hero-image-wrap img {
	display: block;
	width: 100%;
	height: auto;
	border-radius: 10px;
}

.bg-grid {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 16px;
}

.goal-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 16px;
}

.two-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 18px;
}

.three-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 16px;
}

.card,
.module-card,
.contact-form {
	background: #fff;
	border: 1px solid #deebf8;
	border-radius: 14px;
	padding: 22px 18px;
	box-shadow: 0 3px 15px rgba(30, 101, 193, 0.08);
}

.card-hover {
	transition: all 0.35s ease;
}

.card-hover:hover {
	transform: translateY(-6px);
	box-shadow: 0 8px 25px rgba(30, 101, 193, 0.16);
}

.icon-wrap {
	width: 52px;
	height: 52px;
	border-radius: 12px;
	background: rgba(30, 101, 193, 0.1);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 12px;
}

.icon-wrap i {
	font-size: 28px;
	color: #1e65c1;
}

.card h3,
.module-head h4,
.result-card h3 {
	margin: 0 0 10px;
	font-size: 22px;
}

.card p,
.result-card p {
	margin: 0;
	font-size: 14px;
	line-height: 1.75;
	color: #5f6f82;
}

.goal-head {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 10px;
}

.goal-head span {
	width: 34px;
	height: 34px;
	border-radius: 50%;
	background: #1e65c1;
	color: #fff;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	font-weight: 700;
}

.goal-head h3 {
	margin: 0;
	font-size: 20px;
}

.gradient-text {
	margin: 0 0 14px;
	font-size: 24px;
	background: linear-gradient(90deg, #1e65c1, #36b37e);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	color: transparent;
}

.stack-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.stack-item {
	padding-left: 12px;
	border-left: 4px solid #1e65c1;
}

.stack-item h4,
.logic-list h4,
.phase-item h4,
.responsibility-list h4,
.safe-item h4 {
	margin: 0;
	font-size: 17px;
}

.stack-item p,
.logic-list p,
.phase-item p,
.responsibility-list p,
.safe-item p {
	margin: 4px 0 0;
	font-size: 14px;
	line-height: 1.7;
	color: #5f6f82;
}

.logic-list {
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.logic-list li {
	display: flex;
	align-items: flex-start;
	gap: 10px;
}

.logic-icon {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: rgba(30, 101, 193, 0.1);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.logic-icon i {
	color: #1e65c1;
}

.module-grid {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 14px;
}

.module-head {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 8px;
}

.module-icon {
	width: 36px;
	height: 36px;
	border-radius: 8px;
	background: rgba(30, 101, 193, 0.1);
	display: flex;
	align-items: center;
	justify-content: center;
}

.module-icon i {
	color: #1e65c1;
}

.module-card ul {
	margin: 0;
	padding: 0;
	list-style: none;
}

.module-card li {
	position: relative;
	padding-left: 12px;
	font-size: 13px;
	line-height: 1.65;
	color: #5f6f82;
	margin-bottom: 6px;
}

.module-card li::before {
	content: '•';
	position: absolute;
	left: 0;
	color: #1e65c1;
}

.phase-list,
.safe-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.phase-item {
	display: flex;
	gap: 8px;
	align-items: flex-start;
}

.phase-item span {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #1e65c1;
	color: #fff;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 700;
	flex-shrink: 0;
}

.responsibility-list {
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.responsibility-list li {
	padding-left: 10px;
	border-left: 3px solid #d9e6f7;
}

.safe-item {
	padding: 10px;
	background: #f7fafc;
	border: 1px solid #e2edf8;
	border-radius: 10px;
}

.safe-item h4 {
	display: flex;
	align-items: center;
	gap: 6px;
}

.safe-item i {
	color: #1e65c1;
}

.result-section {
	padding: 58px 0;
	background: linear-gradient(90deg, #1e65c1 0%, #36b37e 100%);
}

.result-box {
	max-width: 960px;
	text-align: center;
}

.result-box h2 {
	margin: 0 0 18px;
	font-size: 34px;
	color: #fff;
}

.result-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 14px;
	margin-bottom: 20px;
}

.result-card {
	padding: 18px 14px;
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.12);
	border: 1px solid rgba(255, 255, 255, 0.3);
	backdrop-filter: blur(2px);
}

.result-icon {
	width: 46px;
	height: 46px;
	margin: 0 auto 8px;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.2);
	display: flex;
	align-items: center;
	justify-content: center;
}

.result-icon i {
	font-size: 24px;
	color: #fff;
}

.result-card h3 {
	color: #fff;
	font-size: 19px;
}

.result-card p {
	color: rgba(255, 255, 255, 0.88);
}

.result-btn {
	display: inline-flex;
	padding: 12px 24px;
	border-radius: 10px;
	background: #fff;
	color: #1e65c1;
	font-weight: 700;
	text-decoration: none;
}

.contact-grid {
	display: grid;
	grid-template-columns: 2fr 1fr;
	gap: 18px;
}

.contact-form {
	background: #f8fafc;
}

.form-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.form-item {
	margin-bottom: 12px;
}

.form-item label {
	display: block;
	margin-bottom: 6px;
	font-size: 14px;
	color: #374151;
}

.form-item input,
.form-item select,
.form-item textarea {
	width: 100%;
	box-sizing: border-box;
	padding: 10px 12px;
	font-size: 14px;
	border: 1px solid #d5dee9;
	border-radius: 8px;
	outline: none;
}

.form-item input:focus,
.form-item select:focus,
.form-item textarea:focus {
	border-color: #1e65c1;
	box-shadow: 0 0 0 3px rgba(30, 101, 193, 0.16);
}

.contact-aside {
	border-radius: 14px;
	padding: 24px 20px;
	color: #fff;
	background: linear-gradient(135deg, #1e65c1 0%, #36b37e 100%);
}

.contact-aside h3 {
	margin: 0 0 18px;
	font-size: 30px;
}

.person-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.person-item {
	display: flex;
	align-items: center;
	gap: 10px;
}

.person-icon {
	width: 42px;
	height: 42px;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.2);
	display: flex;
	align-items: center;
	justify-content: center;
}

.person-name {
	margin: 0 0 2px;
	font-size: 13px;
	opacity: 0.82;
}

.person-phone {
	margin: 0;
	font-size: 20px;
	font-weight: 600;
}

.company {
	margin-top: 20px;
	padding-top: 12px;
	border-top: 1px solid rgba(255, 255, 255, 0.25);
}

.company p {
	margin: 0 0 4px;
	font-size: 13px;
	opacity: 0.82;
}

.company h4 {
	margin: 0;
	font-size: 20px;
}

.fade-in {
	animation: fadeIn 0.8s ease-in-out forwards;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@media (max-width: 1200px) {
	.bg-grid,
	.module-grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 992px) {
	.education-main {
		padding-top: 56px;
	}

	.section-py {
		padding: 48px 0;
	}

	.hero-grid,
	.contact-grid,
	.two-grid,
	.three-grid,
	.goal-grid {
		grid-template-columns: 1fr;
	}

	.hero-points {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 768px) {
	.container-custom {
		padding: 0 14px;
	}

	.section-py {
		padding: 34px 0;
	}

	.form-grid,
	.bg-grid,
	.goal-grid,
	.module-grid,
	.result-grid {
		grid-template-columns: 1fr;
	}

	.hero-section h1 {
		font-size: 32px;
	}

	.hero-section p,
	.section-head p {
		font-size: 14px;
	}

	.result-box h2 {
		font-size: 26px;
	}
}
</style>
